import React from 'react';
import logo from './../assets/images/logo-place.png'
import { Link } from 'react-router-dom';
import scanIcon from './../assets/images/scanIcon.png'
import assessmentIcon from './../assets/images/assessment-icon.png'
import assessmentLocalStoregService from "../services/assessmentLocalStoreg"

const SelectOpration = props => {

    const handlerRecoveryResult = async () => {
        if(await assessmentLocalStoregService.getAnswer()){
            props.history.push('/survey/history');
        } else {
            props.history.push('/survey/wellcome');
        }
    }

    return (
        <React.Fragment>
            <div className="gradient-backgroun full-page-gradient">
                <div className="brand-header-logo center">
                    <img src={logo} alt="logo" />
                </div>
                <div className="had-container navigation-page-vertica-parent">
                    <div className="navigation-page-vertica-item">
                        <button onClick={handlerRecoveryResult} className="main-navigation waves-effect waves-light btn"><img src={assessmentIcon} className="navigation-page-icon-button" alt="Tack Assessment"/> Take Assessment</button>
                        <br/>
                        <Link to="/auth/login" className="main-navigation waves-effect waves-light btn"><img src={scanIcon} className="navigation-page-icon-button" alt="Scan Result"/>Scan Result</Link>
                    </div>

                </div>
            </div>
        </React.Fragment>
    );
}

export default SelectOpration;